// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getRedes as listRedesAPI,
    getRed as getRedAPI,
    addRed as addRedAPI,
    updateRed as updateRedAPI,
    deleteRed as deleteRedAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { redesApiResponseError, redesApiResponseSuccess } from './actions';
import { RedesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getRed({ payload: { id } }) {
    try {
        const response = yield call(getRedAPI, id );
        const redItem = response.data.data;
        yield put(redesApiResponseSuccess(RedesActionTypes.GET_RED, redItem));
    } catch (error) {
        yield put(redesApiResponseError(RedesActionTypes.GET_RED, error));
    }
}

function* addRed({payload:red}){
    try{
        const response = yield call(addRedAPI,{...red})
        const redItem = response.data
        yield put(redesApiResponseSuccess(RedesActionTypes.ADD_RED,redItem))
    } catch(error){
        yield put(redesApiResponseError(RedesActionTypes.ADD_RED,error))
    }
}

function* updateRed({payload:red}){
    try{
        const response = yield call(updateRedAPI,{...red})
        const redItem = response.data.data
        yield put(redesApiResponseSuccess(RedesActionTypes.UPDATE_RED,redItem))
    }catch(error){
        yield put(redesApiResponseError(RedesActionTypes.UPDATE_RED,error))
    }
}
function* deleteRed({payload:{id}}){
    try{
        const response = yield call(deleteRedAPI,id)
        const redItem = response.data.id
        yield put(redesApiResponseSuccess(RedesActionTypes.DELETE_RED,redItem))
    }catch(error){
        yield put(redesApiResponseError(RedesActionTypes.DELETE_RED,error))
    }
}

/**
 * List contactos
 */
function* listRedes({payload:params}) {
    try {
        const response = yield call(listRedesAPI, { ...params });
        const listaRedes = response.data.data;
        yield put(redesApiResponseSuccess(RedesActionTypes.LIST_REDES, listaRedes));
    } catch (error) {
        yield put(redesApiResponseError(RedesActionTypes.LIST_REDES, error));
    }
}


export function* watchGetRed(): any {
    yield takeEvery(RedesActionTypes.GET_RED, getRed);
}

export function* watchListRedes(): any {
    yield takeEvery(RedesActionTypes.LIST_REDES, listRedes);
}

export function* watchAddRed():any{
    yield takeEvery(RedesActionTypes.ADD_RED,addRed)
}
export function* watchUpdateRed():any{
    yield takeEvery(RedesActionTypes.UPDATE_RED,updateRed)
}
export function* watchDeleteRed():any{
    yield takeEvery(RedesActionTypes.DELETE_RED,deleteRed)
}


function* redesSaga(): any {
    yield all([
        fork(watchGetRed),
        fork(watchListRedes),
        fork(watchAddRed),
        fork(watchUpdateRed),
        fork(watchDeleteRed),
    ]);
}

export default redesSaga;
